import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import { Form } from '@enterprise-ui/canvas-ui-react';
import { Controller } from 'react-hook-form';

var _excluded = ["name", "rules", "className", "placeholder", "formContext", "onChange", "onBlur", "label", "hintText"],
  _excluded2 = ["onChange", "onBlur"];
var FormTextField = function FormTextField(_ref) {
  var name = _ref.name,
    rules = _ref.rules,
    className = _ref.className,
    placeholder = _ref.placeholder,
    formContext = _ref.formContext,
    _onChange = _ref.onChange,
    _onBlur = _ref.onBlur,
    label = _ref.label,
    hintText = _ref.hintText,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var control = formContext.control;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    key: name,
    control: control,
    rules: rules,
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
        controllerOnChange = _ref2$field.onChange,
        controllerOnBlur = _ref2$field.onBlur,
        field = _objectWithoutProperties(_ref2$field, _excluded2),
        _ref2$fieldState = _ref2.fieldState,
        invalid = _ref2$fieldState.invalid,
        error = _ref2$fieldState.error;
      return (
        /*#__PURE__*/
        // TODO - Split into <Input.Label> and <Input.Text>
        React.createElement(Form.Field, _extends({}, restProps, field, {
          id: name,
          className: className,
          placeholder: placeholder,
          label: label,
          hintText: hintText,
          error: invalid,
          errorText: error === null || error === void 0 ? void 0 : error.message,
          disableFieldInfo: !invalid && !hintText,
          onChange: function onChange(value) {
            controllerOnChange(value);
            typeof _onChange === 'function' && _onChange(value);
          },
          onBlur: function onBlur(e) {
            controllerOnBlur(e);
            typeof _onBlur === 'function' && _onBlur(e);
          }
        }))
      );
    }
  });
};

export { FormTextField as default };
